const AUTHORIZE_CRM = 'AUTHORIZE_CRM';
const AUTHORIZE_SUCCESS = 'AUTHORIZE_SUCCESS';
const AUTHORIZE_FAILED = 'AUTHORIZE_FAILED';
const APPROVE_STARTED = 'APPROVE_STARTED';
const APPROVE_SUCCESS = 'APPROVE_SUCCESS';
const APPROVE_FAILED = 'APPROVE_FAILED';
const REJECT_STARTED = 'REJECT_STARTED';
const REJECT_SUCCESS = 'REJECT_SUCCESS';
const REJECT_FAILED = 'REJECT_FAILED';

const authorize = (authKey) => {
	return {
		type: AUTHORIZE_CRM,
		authKey,
	};
};

const authorizeSuccess = (userDetails = null) => {
	return {
		type: AUTHORIZE_SUCCESS,
		userDetails,
	};
};
const authorizeFailed = () => {
	return {
		type: AUTHORIZE_FAILED,
	};
};

const approve = (authKey) => {
	return {
		type: APPROVE_STARTED,
		authKey,
	};
};

const approveSuccess = () => {
	return {
		type: APPROVE_SUCCESS,
	};
};

const approveFailed = () => {
	return {
		type: APPROVE_FAILED,
	};
};

const reject = (authKey) => {
	return {
		type: REJECT_STARTED,
		authKey,
	};
};

const rejectSuccess = () => {
	return {
		type: REJECT_SUCCESS,
	};
};

const rejectFailed = () => {
	return {
		type: REJECT_FAILED,
	};
};

export default {
	types: {
		AUTHORIZE_CRM,
		AUTHORIZE_SUCCESS,
		AUTHORIZE_FAILED,
		REJECT_STARTED,
		APPROVE_STARTED,
		APPROVE_SUCCESS,
		APPROVE_FAILED,
		REJECT_SUCCESS,
		REJECT_FAILED,
	},
	creators: {
		authorize,
		authorizeSuccess,
		authorizeFailed,
		approve,
		approveSuccess,
		approveFailed,
		reject,
		rejectSuccess,
		rejectFailed,
	},
};
